import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';


interface AsyncState {
  isLoading: {
    brandDetails: boolean;
    brandEdit: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  brandDetails: any;
  statusData: any;
  editBrandRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;

}

const initialState: TableState = {
  isLoading: {
    brandDetails: true,
    brandEdit: false,
  },
  isSuccess: false,
  isError: false,
  brandDetails: null,
  statusData: null,
  editBrandRes: null,
  isLogout: false,
  fullResponse: [],
  errorMsg: null,
};



export const fetchBrandById = createAsyncThunk(
  "products/fetchBrandById",
  async (id: any, thunkAPI) => {
    try {
      return await Service.getOneBrand(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const editBrand = createAsyncThunk('editCategoryData', async (data: any, thunkAPI) => {
  try {
    return await Service.editBrand(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});



export const brandDetailsSlice = createSlice({
  name: 'brand details',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading.brandDetails = false;
      state.isSuccess = false;
      state.isError = false;
      state.brandDetails = initialState.brandDetails;
      state.editBrandRes = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchBrandById.pending, (state, action: any) => {
        state.isLoading.brandDetails = true;
        state.isError = false;
        state.errorMsg = null;
        state.brandDetails = null;
      })
      .addCase(fetchBrandById.fulfilled, (state, action: any) => {
        state.isLoading.brandDetails = false;
        state.isSuccess = true;
        state.isError = false;
        state.brandDetails = action.payload.data;
        state.errorMsg = null;
      })
      .addCase(fetchBrandById.rejected, (state) => {
        state.isLoading.brandDetails = false;
        state.isError = true;
        state.brandDetails = null;

      })

      .addCase(editBrand.pending, (state) => {
        state.isLoading.brandEdit = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.editBrandRes = null;
      })
      .addCase(editBrand.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Brand Updated successfully', "success");
        state.isLoading.brandEdit = false;
        state.isSuccess = true;
        state.isError = false;
        state.editBrandRes = action.payload;
      })
      .addCase(editBrand.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.brandEdit = false;
        state.isSuccess = false;
        state.isError = true;
        state.editBrandRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


  },
});

export const { reset } = brandDetailsSlice.actions;


export default brandDetailsSlice.reducer;
